










import { Component, Prop, Vue } from 'vue-property-decorator';
import * as Common from '@/agiles/common';

@Component
export default class GlobalMenuItem extends Vue {
  @Prop() public to!: string;
  @Prop() public caption!: string;
  @Prop() public icon?: string;
  @Prop({default:null}) public svg: string;
  @Prop({ default: null }) public perm: string;
  @Prop({default:true}) public vertical:boolean;
  @Prop({default:null}) public count:number;
  @Prop() public tooltip: string;
  @Prop({default:false}) public disabled: boolean;

  public onClick(){
      if(this.to) this.$router.push(this.to);
      this.$emit("click");      
  }
  public get style(){
      if (this.vertical) return {'display': 'flex', 'flex-direction': 'column' , 'justify-content': 'space-around', 'align-items': 'center'}
      return {'display': 'flex','justify-content': 'start','align-items': 'center'};
  }  
}
